/* eslint-disable no-await-in-loop */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { Button, Checkbox, Drawer, message } from 'antd';

import Utils from '../../../Assets/Scripts/Utils';
import { getSettings } from '../../Settings/API/SettingsAPI';
import { downloadOsCatalogItemAsPdf } from '../API/osWorkOrderApi';

import { mergeOsVariableValues } from './OsUploadDownloadSection';

async function fetchOsCatalogItems() {
  const settings = await getSettings();
  return Array.isArray(settings?.osTemplates) ? settings.osTemplates : [];
}

function loadCatalogItems(setCatalogItems) {
  let cancelled = false;

  fetchOsCatalogItems()
    .then((items) => {
      if (!cancelled) setCatalogItems(items);
    })
    .catch((error) => {
      Utils.logError(error);
      if (!cancelled) setCatalogItems([]);
    });

  return () => {
    cancelled = true;
  };
}

function toggleSelectedCatalogId(selectedIds, itemId, isChecked) {
  if (isChecked) return [...selectedIds, itemId];
  return selectedIds.filter((id) => id !== itemId);
}

async function downloadCatalogItemSafely(item, values) {
  try {
    await downloadOsCatalogItemAsPdf(item.id, values, item);
  } catch (error) {
    message.error(`Não foi possível baixar ${item.label}.`);
  }
}

async function downloadSelectedCatalogItems(catalogItems, selectedIds, task, form) {
  const values = mergeOsVariableValues(task, form);
  const selectedItems = catalogItems.filter((item) => selectedIds.includes(item.id));

  for (let index = 0; index < selectedItems.length; index += 1) {
    await downloadCatalogItemSafely(selectedItems[index], values);
  }
}

async function runCatalogSelectionDownload({
  selectedIds,
  catalogItems,
  task,
  form,
  onDownloadSelectionChange,
}) {
  onDownloadSelectionChange(true);
  try {
    await downloadSelectedCatalogItems(catalogItems, selectedIds, task, form);
  } finally {
    onDownloadSelectionChange(false);
  }
}

function OsWorkOrderCatalogList({ catalogItems, selectedIds, onToggleItem }) {
  return (
    <div role="list" aria-label="Catálogo de ordem de serviço">
      {catalogItems.map((item) => (
        <div role="listitem" key={item.id} style={{ marginBottom: 8 }}>
          <Checkbox
            checked={selectedIds.includes(item.id)}
            onChange={(event) => onToggleItem(item.id, event.target.checked)}
          >
            {item.label}
          </Checkbox>
        </div>
      ))}
    </div>
  );
}

function OsWorkOrderDrawer({
  open = false,
  task,
  form,
  isDownloadingSelection = false,
  onClose,
  onDownloadSelectionChange,
}) {
  const [catalogItems, setCatalogItems] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const isLevaRunningRef = useRef(false);

  useEffect(() => {
    if (!open) {
      setSelectedIds([]);
      setCatalogItems([]);
      return undefined;
    }

    return loadCatalogItems(setCatalogItems);
  }, [open]);

  const closeDrawer = () => {
    setSelectedIds([]);
    onClose();
  };

  const isDownloadDisabled =
    selectedIds.length === 0 || catalogItems.length === 0 || isDownloadingSelection;

  const downloadSelected = async () => {
    if (isLevaRunningRef.current || isDownloadingSelection || selectedIds.length === 0) return;

    isLevaRunningRef.current = true;
    try {
      await runCatalogSelectionDownload({
        selectedIds,
        catalogItems,
        task,
        form,
        onDownloadSelectionChange,
      });
    } finally {
      isLevaRunningRef.current = false;
    }
  };

  return (
    <Drawer
      title="Ordem de Serviço"
      placement="right"
      open={open}
      onClose={closeDrawer}
      zIndex={1100}
      getContainer={() => document.body}
      destroyOnClose
      className="os-work-order-drawer"
    >
      <OsWorkOrderCatalogList
        catalogItems={catalogItems}
        selectedIds={selectedIds}
        onToggleItem={(itemId, isChecked) =>
          setSelectedIds((current) => toggleSelectedCatalogId(current, itemId, isChecked))
        }
      />
      <Button
        type="primary"
        disabled={isDownloadDisabled}
        loading={isDownloadingSelection}
        onClick={downloadSelected}
        style={{ marginTop: 16 }}
      >
        Download do PDF
      </Button>
    </Drawer>
  );
}

export default OsWorkOrderDrawer;
